import * as React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { NoImagePlaceholder } from './index';

// Styles
const s = require('./ItemThumb.css');

// Props
interface IItemThumbProps {
    onThumbClick?: (image: string | null, imageThumb: string | null) => void;
    image: string | null;
    imageThumb?: string | null;
}

// Component
@observer
export class ItemThumb extends React.Component<IItemThumbProps, {}> {
    static get defaultProps(): IItemThumbProps {
        return {
            onThumbClick: null,
            image: null,
            imageThumb: null
        };
    }

    constructor(props: IItemThumbProps) {
        super(props);
    }

    @observable private errorLoadingImage: boolean = false;

    public render() {
        return (this.errorLoadingImage || (this.props.image === null && this.props.imageThumb === null)) ? (
            <NoImagePlaceholder />
        ) : (this.props.imageThumb || this.props.image) ? (
            <button className={s.thumb} onClick={this.handleThumbClick}>
                <img onError={this.onImageLoadError} src={this.props.imageThumb ? this.props.imageThumb : this.props.image} />
            </button>
        ) : null;
    }

    private handleThumbClick = () => {
        if (this.props.onThumbClick) {
            this.props.onThumbClick(this.props.image, this.props.imageThumb);
        }
    }

    private onImageLoadError = () => {
        this.errorLoadingImage = true;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/item/ItemThumb.tsx